// 判断是否在iOS(存在BUG)
export const isIOS = () => {
    const u = window.navigator.userAgent;

    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

export const isAndroid = () => {
    const u = window.navigator.userAgent.toLocaleLowerCase();

    return u.includes('Android');
};

export const isClient = () => {
    return !!window?.grounds?.getUserInfo;
};

const isfastmode = () => {
    return (() => {
        let isfastmode = 1;

        try {
            localStorage.setItem('checkfastmode', 1);
            isfastmode = 0;
        } catch (e) {
            console.error(e);
        }

        return isfastmode;
    })();
};

export const setSession = (key, value) => {
    if (isfastmode()) return '';

    sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSession = key => {
    if (isfastmode()) return '';

    return JSON.parse(sessionStorage.getItem(key)) || '';
};

export const setlocal = (key, value) => {
    if (isfastmode()) return '';
    localStorage.setItem(key, JSON.stringify(value));
};

export const getlocal = key => {
    if (isfastmode()) return '';

    return JSON.parse(localStorage.getItem(key));
};
export const newGoPage = data => {
    if (window.grounds.dispatchByLink && !isIOS()) {
        const type = data.type;
        const url = data.url;

        delete data.type;
        delete data.url;
        data = {
            link: {
                type,
                url,
            },
            pageLogParams: {
                ...data,
            },
        };
        window.grounds.dispatchByLink(JSON.stringify(data));
    } else {
        window.grounds.goTo(isIOS() ? data : JSON.stringify(data));
    }
};
// 获取 margin 和 padding
export const getStyle = (obj, attr) => {
    if (obj.currentStyle) {
        return obj.currentStyle[attr];
    } else {
        return document.defaultView.getComputedStyle(obj, null)[attr];
    }
};
